// import {useAuth0} from '@auth0/auth0-react'
import * as Sentry from '@sentry/react'
// import {getUserRoles} from './get-user-roles'
import {useSelector} from 'react-redux'
import {selectEffectiveRole} from '../app-store/selector'

function useUserRoles() {
  // const {user} = useAuth0()
  const userRoles = useSelector(selectEffectiveRole)

  if (userRoles) {
    // const userRoles = getUserRoles(user)
    Sentry.setUser({useUser: userRoles})
    return {
      roles: userRoles,
    }
  }
  return {roles: []}
}

export {useUserRoles}
